import { useEffect, useState } from 'react';

// Confetti particle component
const ConfettiParticle = ({ style }) => (
  <div
    className="absolute w-3 h-3 rounded-sm animate-confetti-fall"
    style={style}
  />
);

const UnlockCelebration = ({ show, featureName, onComplete }) => {
  const [particles, setParticles] = useState([]);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (show) {
      setVisible(true);
      
      // Generate confetti particles
      const colors = [
        '#10b981', // emerald
        '#f59e0b', // amber
        '#3b82f6', // blue
        '#8b5cf6', // purple
        '#ec4899', // pink
        '#ffffff', // white
      ];
      
      const newParticles = Array.from({ length: 50 }, (_, i) => ({
        id: i,
        left: `${Math.random() * 100}%`,
        animationDelay: `${Math.random() * 0.5}s`,
        animationDuration: `${1 + Math.random() * 1}s`,
        backgroundColor: colors[Math.floor(Math.random() * colors.length)],
        transform: `rotate(${Math.random() * 360}deg)`,
      }));
      
      setParticles(newParticles);
      
      // Auto-close after animation
      const timer = setTimeout(() => {
        setVisible(false);
        setParticles([]);
        onComplete?.();
      }, 3000);
      
      return () => clearTimeout(timer);
    }
  }, [show, onComplete]);

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-[100] pointer-events-none overflow-hidden">
      {/* Confetti */}
      {particles.map((particle) => (
        <ConfettiParticle
          key={particle.id}
          style={{
            left: particle.left,
            top: '-20px',
            backgroundColor: particle.backgroundColor,
            animationDelay: particle.animationDelay,
            animationDuration: particle.animationDuration,
            transform: particle.transform,
          }}
        />
      ))}
      
      {/* Center celebration message */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-auto">
        <div className="bg-gradient-to-br from-emerald-600 to-emerald-700 rounded-3xl p-8 shadow-2xl shadow-emerald-500/50 animate-bounce-in border-2 border-emerald-400/30">
          <div className="text-center">
            <div className="text-5xl mb-3">🎉</div>
            <h2 className="text-2xl font-bold text-white mb-2">Unlocked!</h2>
            <p className="text-emerald-100 text-lg">{featureName}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

// Coin reward toast component
export const CoinRewardToast = ({ coins, message, show }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (show) {
      setVisible(true);
      const timer = setTimeout(() => setVisible(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [show]);

  if (!visible) return null;

  return (
    <div className="fixed top-20 left-1/2 -translate-x-1/2 z-[100] animate-slide-down">
      <div className="bg-gradient-to-r from-amber-500 to-amber-600 rounded-full px-6 py-3 shadow-lg shadow-amber-500/30 flex items-center gap-3">
        <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center">
          <span className="text-lg">🪙</span>
        </div>
        <div>
          <p className="text-white font-bold text-lg">+{coins} Coins!</p>
          {message && <p className="text-amber-100 text-sm">{message}</p>}
        </div>
      </div>
    </div>
  );
};

// Add these animations to your global CSS or tailwind config
// Put in your index.css or App.css:
/*
@keyframes confetti-fall {
  0% {
    transform: translateY(0) rotate(0deg);
    opacity: 1;
  }
  100% {
    transform: translateY(100vh) rotate(720deg);
    opacity: 0;
  }
}

@keyframes bounce-in {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes slide-down {
  0% {
    transform: translateX(-50%) translateY(-100%);
    opacity: 0;
  }
  100% {
    transform: translateX(-50%) translateY(0);
    opacity: 1;
  }
}

.animate-confetti-fall {
  animation: confetti-fall linear forwards;
}

.animate-bounce-in {
  animation: bounce-in 0.5s ease-out forwards;
}

.animate-slide-down {
  animation: slide-down 0.3s ease-out forwards;
}
*/

export default UnlockCelebration;
